var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9512 2.00819C20.9512 2.00819 19.2129 2.97873 18.2463 3.25382C17.7275 2.69004 17.038 2.29044 16.2711 2.10908C15.5042 1.92772 14.6969 1.97334 13.9583 2.23977C13.2197 2.5062 12.5854 2.98059 12.1415 3.59878C11.6974 4.21697 11.465 4.94912 11.4756 5.69623V6.51037C9.96173 6.54746 8.46172 6.23015 7.10907 5.58668C5.75641 4.94321 4.59314 3.99357 3.72283 2.82233C3.72283 2.82233 0.277166 10.1496 8.02992 13.4061C6.25586 14.5442 4.14248 15.1149 2 15.0344C9.75275 19.1051 19.2283 15.0344 19.2283 5.6718C19.2276 5.44503 19.2045 5.21881 19.1594 4.99607C20.0386 4.17663 20.9512 2.00819 20.9512 2.00819Z",
    stroke: "#484848",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon _twitter_.65ef1de656f73da10aca48007dc388b0.svg";
export { ForwardRef as ReactComponent };